const getWarehouseOptions = (orderWarehouseInfos: any) => {
  const uniqueMap = new Map<number, string>();

  orderWarehouseInfos.forEach((w: any) => {
    if (!uniqueMap.has(w.warehouseId)) {
      uniqueMap.set(w.warehouseId, w.warehouseName);
    }
  });

  return Array.from(uniqueMap, ([key, value]) => ({ key, value }));
};

export const shippingLabelModalUtils = {
  getWarehouseOptions,
};
